<template>
	<div class="submission" :style="style">
		<TextSubmission v-if="isText" :text="title" />
	</div>
</template>

<script>
import { enums } from 'protoswipe-shared'
import TextSubmission from '@/components/shared/TextSubmission'

export default {
	name: 'Submission',
	props: {
		campaign: Object,
		title: String,
		image: Object,
		drawing: String
	},
	computed: {
		isText() {
			return this.campaign.type === enums.CampaignType.text
		},
		src() {
			if (!this.drawing && !this.image) return null
			return this.drawing || process.env.VUE_APP_API_BASE + this.image.url
		},
		style() {
			const backgroundImage = `url('${this.src}')`
			return this.isText ? undefined : { backgroundImage }
		}
	},
	components: {
		TextSubmission
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/layout';
@import '~scss/components';

.submission {
	@extend %square;
	@include submission-img;
	position: relative;

	&::after {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		box-shadow: 0 0 2rem 0 rgba(black, 0.05) inset;
	}
}
</style>
